module.exports = __webpack_public_path__ + "img/award.bab5364a.svg";